<template>
  <zm-skeleton
    :class="wrapperClass"
    :loading="loading"
    animated
  >
    <template slot="template">
      <zm-skeleton-item :class="imageClass" variant="image" />
    </template>
    <img :alt="alt" :class="imageClass" :src="imgLink" srcset="" tabindex="-1" />
  </zm-skeleton>
</template>

<script>
import { preLoadImage } from '@/utils/preload';

export default {
  name: 'LazyImage',
  props: {
    imgLink: String,
    imageClass: String,
    wrapperClass: String,
    alt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  async created() {
    try {
      this.loading = true;
      await preLoadImage(this.imgLink);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss">

</style>
